import {
    AnalyticsIcon
} from "@/components/icons";
import React, { FC } from "react";
import { PiExam } from "react-icons/pi";
import { MdGavel } from "react-icons/md";
import { AiFillQuestionCircle } from "react-icons/ai";
import { LuFolder, LuSettings } from "react-icons/lu";
import { IconCash, IconRefresh, IconDownload, IconChartBar } from "@tabler/icons-react";
import { SideBarRouteOption, ISidebarProps } from "@/types";

// Wrapper components to handle isActive prop for react-icons
const ExamIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(PiExam, props);

const GavelIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(MdGavel, props);

const QuestionCircleIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(AiFillQuestionCircle, props);

const FolderIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(LuFolder, props);

const SettingsIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(LuSettings, props);

const RetakeIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(IconRefresh, props);

const ExportIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(IconDownload, props);

const BatchMonitoringIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(IconChartBar, props);

const examinerRoutes: SideBarRouteOption[] = [
    {
        name: "Analytics",
        path: "/examiner-account",
        icon: AnalyticsIcon,
    },
    {
        name: "Questions",
        path: "/examiner-account/questions",
        icon: QuestionCircleIcon,
    },
    {
        name: "Education Programs",
        path: "/examiner-account/education-programs",
        icon: FolderIcon,
    },
    {
        name: "Exam Schedules",
        path: "/examiner-account/exam-schedules",
        icon: ExamIcon,
    },
    {
        name: "Appeals",
        path: "/examiner-account/appeals",
        icon: GavelIcon,
    },
    {
        name: "Retake Requests",
        path: "/examiner-account/retake-requests",
        icon: RetakeIcon,
    },
    {
        name: "Export Sessions",
        path: "/examiner-account/exam-session-export",
        icon: ExportIcon,
    },
    {
        name: "Batch Monitoring",
        path: "/examiner-account/exam-results/batch-monitoring",
        icon: BatchMonitoringIcon,
    }
];

export default examinerRoutes;
